<template>
  <div class="tx-switch">
    <button
        type="button"
        class="tx-switch__opt tx-switch__opt--deposit"
        :class="{ 'is-active': selected === 'deposits' }"
        @click="setSelected('deposits')"
    >
      <i class="fa-solid fa-arrow-down-long"></i>
      <span>{{ $t('monetary.deposits') }}</span>
    </button>
    <button
        type="button"
        class="tx-switch__opt tx-switch__opt--withdraw"
        :class="{ 'is-active': selected === 'withdrawals' }"
        @click="setSelected('withdrawals')"
    >
      <i class="fa-solid fa-arrow-up-long"></i>
      <span>{{ $t('monetary.withdrawals') }}</span>
    </button>
    <button
        type="button"
        class="tx-switch__opt tx-switch__opt--all"
        :class="{ 'is-active': selected === 'all' }"
        @click="setSelected('all')"
    >
      <i class="fa-solid fa-layer-group"></i>
      <span>{{ $t('monetary.allTransactions') }}</span>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: 'deposits', // default selected value
    };
  },
  methods: {
    setSelected(value) {
      this.selected = value;
      this.$emit('input', this.selected);
    }
  }
};
</script>

<style scoped lang="scss">
.tx-switch {
  display: inline-flex;
  background: #f0f1f7;
  border-radius: 12px;
  padding: 4px;
  gap: 4px;
}
.tx-switch__opt {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: none;
  background: transparent;
  color: #6e6b7b;
  font-weight: 600;
  font-size: 0.82rem;
  padding: 0.45rem 0.95rem;
  border-radius: 9px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, transform 0.12s ease;

  i { font-size: 0.85rem; }

  &:hover { color: #2b2f42; }
  &:active { transform: scale(0.97); }

  /* Active pill — white chip + colored text/glow per type */
  &.is-active {
    background: #fff;
    box-shadow: 0 3px 9px rgba(20, 24, 50, 0.13);
  }
  &--deposit.is-active { color: #28c76f; }
  &--withdraw.is-active { color: #ea5455; }
  &--all.is-active { color: #007bff; }
}

/* Dark mode */
body.dark-layout {
  .tx-switch { background: var(--crm-dark-surface-2, #2e3850); }
  .tx-switch__opt { color: #b4b7bd; }
  .tx-switch__opt:hover { color: #fff; }
  .tx-switch__opt.is-active { background: var(--crm-dark-surface, #232c3e); }
}
</style>
